import { render } from "./sysUserTemp.vue?vue&type=template&id=68dd056c"
import script from "./sysUserTemp.vue?vue&type=script&lang=js"
export * from "./sysUserTemp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__